import { css } from "@emotion/css";
import styled from "@emotion/styled";

import { DisabledButtonToolipFix } from "../../common/components/ActionDisabledTooltip";
import { fadeIn } from "../../core/styles/Animation";

export const emptyResultsImage = css`
    width: 214px;
    height: 156px;
`;

export const emptyResultsImageContainer = css`
    max-width: 400px;
    margin-bottom: 51px;

    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 16px;
`;

export const emptyResultsContainer = css`
    padding: 16px 0;
    text-align: center;
    ${fadeIn};
`;

export const AddButton = styled(DisabledButtonToolipFix)`
    height: 40px !important;
`;
